import React from 'react';
import { Link } from 'react-router-dom';
import VideoCard from '../cards/VideoCard';

const mockVideos = [
    { 
        id: 1, 
        title: 'IWD 2022 | Inclusive Workplaces: The Key to A Sustainable Tomorrow', 
        tag: 'Microsoft',
        thumbnail: 'https://i.ytimg.com/vi/ERp0-G5s_4U/maxresdefault.jpg',
        link: '/blog/2022/08/iwd-2022-inclusive-workplaces-the-key-to-a-sustainable-tomorrow'
    },
    { 
        id: 2, 
        title: 'IWD 2022 | #BreakTheBias: Smashing Stereotypes & Breaking the Glass Ceiling', 
        tag: 'Course',
        thumbnail: 'https://i.ytimg.com/vi/3Ie3b1KyA5A/maxresdefault.jpg',
        link: '/blog/2022/08/iwd-2022-number-breakthebias-smashing-stereotypes-and-breaking-the-glass-ceiling'
    },
    { 
        id: 3, 
        title: 'Chay Geok Lee - Women In Leadership Interview Series', 
        tag: 'Video',
        thumbnail: 'https://i.ytimg.com/vi/YvW8mVa2R6s/maxresdefault.jpg',
        link: '/blog/2022/05/chay-geok-lee-women-in-leadership-interview-series'
    },
];

const LatestVideos = () => {
    return (
        <section className="bg-cyan-50/50 py-20">
            <div className="container mx-auto px-4">
                <header className="text-center mb-12">
                    <h2 className="text-4xl font-bold text-cyan-600 tracking-tight">HTS Academy</h2>
                </header>
                <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {mockVideos.map(video => (
                        <VideoCard key={video.id} video={video} />
                    ))}
                </ul>
                <div className="text-center mt-16">
                    <Link
                        to="/videos"
                        className="inline-block bg-cyan-500 text-white font-bold py-3 px-8 rounded-full hover:bg-cyan-600 transition-colors duration-300 text-lg"
                    >
                        View All Videos
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default LatestVideos; 